import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import image1 from './images/mocktail/classic_mint.png'
import image2 from './images/mocktail/blue_lagoon.png'
import image3 from './images/mocktail/green_apple.png'
import image4 from './images/mocktail/peach.png'
import image5 from './images/mocktail/cranberry.png'
import image6 from './images/mocktail/orange.png'
import image7 from './images/mocktail/lemon_tea.png'
import image8 from './images/mocktail/peach_tea.png'
import image9 from './images/mocktail/kiwi_tea.png'
import image10 from './images/mocktail/strawberry_tea.png'
import './menu.css'
import NavigationBar from './nav';
import NewNav from './canvas';
import Aos from 'aos';
import "aos/dist/aos.css";
import { useEffect } from 'react';

function Mocktail() {
  const products = [
    { id: 1, name: "Classic Mint Mojito", image: image1 },
    { id: 2, name: "Blue Lagoon Mojito", image: image2 },
    { id: 3, name: "Green Apple Mojito", image: image3 },
    { id: 4, name: "Peach Mojito", image: image4 },
    { id: 5, name: "Cranberry Strawberry", image: image5 },
    { id: 6, name: "Orange Mix Berry Mojito", image: image6 },
    { id: 7, name: "Lemon Iced Tea", image: image7 },
    { id: 8, name: "Peach Iced Tea", image: image8 },
    { id: 9, name: "Kiwi Iced Tea", image: image9 },
    { id: 10, name: "Strawberry Iced Tea", image: image10 },
  ]
  useEffect(() => {
        Aos.init({ duration: "1000" })
      })
  return (
    <>
    <Container fluid>
              <Row>
              <NavigationBar/>
              <NewNav/>
                <Col id='mockTop'>  
                <Row>
                  <Col id='rockHeading'>
                  <p data-aos="zoom-in">Mocktails & Ice Tea's</p>
                  </Col>
                </Row>
                </Col>
              </Row>
            </Container>
      <Container>
        <Row>
          <Col md={12} style={{justifyContent: "center",gap: "20px"}}>
            <Row>
              {products.map((p)=>(
              <Col xs={3} s md={3} key={products.id} style={{ marginTop: "20px",textAlign:"center",gap:"20px"}}>
                <Card data-aos="zoom-in" style={{border:"none"}}>
                  <Card.Img id='CardImg' 
                  src={p.image} />
                  <Card.Body style={{padding:"5px 0px"}}>
                    <Card.Title id='cardName'>{p.name}</Card.Title>
                  </Card.Body>
                </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Mocktail